import { regexEmail } from './regex';

export const validateEmail = (email: string) => {
  return regexEmail.test(String(email).trim().toLowerCase());
};
